import { TEDFormatIntAsFloat } from './TEDFormatIntAsFloat';
import { TEDDisplayDegrees } from '../Displayers/TEDDisplayDegrees';
import { TEDParseDegrees } from '../Parsers/TEDParseDegrees';

class TEDFormatIntAsDegrees extends TEDFormatIntAsFloat {
  parser = TEDParseDegrees.getInstance();
  displayer = TEDDisplayDegrees.getInstance();
}

export { TEDFormatIntAsDegrees };
